import React, { forwardRef, useEffect, useImperativeHandle, useRef, useState } from 'react'
import Accordion from '../../../../components/Accordion/Accordion'
import FormCreator from '../../../../components/Forms/FormCreator'
import Buttons from '../../../../components/ui/button/Buttons'
import { OtherInformationData } from './OtherInformation.data'
import { useUpdateCorporateMemberOtherInformationByAdminMutation } from '../../../../app/services/corporateMembership/corporateMemberApi'
import ToastService from '../../../../services/toastService/ToastService'
import SwalAlert from '../../../../services/swalService/SwalService'
import { handleConditionBaseFields, includesValueNormalized } from './Utils/OtherInformationUtils'

const OtherInformation = forwardRef((props, ref) => {
  const otherInformationRef = useRef();
  const { error, success } = SwalAlert();
  const [formData, setFormData] = useState(OtherInformationData);
  const [updateOtherInformation, { data: updateOtherInformationData, isLoading: updateOtherInformationLoading, isError: updateOtherInformationIsError, error: updateOtherInformationError, }] = useUpdateCorporateMemberOtherInformationByAdminMutation();



  const handleFormFieldChange = (dataField, value) => {
    const selectedValue = value?.value ?? value;
    const nextFormDataBase = { ...formData, initialState: { ...formData.initialState, [dataField]: selectedValue } };

    if (dataField === "howDidYouLearnSGBCId") {
      let updated = handleConditionBaseFields(selectedValue, nextFormDataBase, "OtherInformationAboutSGBC", 4, 5);
      if (!includesValueNormalized(selectedValue, 5) && !includesValueNormalized(selectedValue, 4)) {
        updated = { ...updated, initialState: { ...updated.initialState, OtherInformationAboutSGBC: null } };
      }
      setFormData(updated);
      return;
    }

    if (dataField === "reasonOfJoining") {
      let updated = handleConditionBaseFields(selectedValue, nextFormDataBase, "OtherReasonOfJoining", 8);
      if (!includesValueNormalized(selectedValue, 8)) {
        updated = { ...updated, initialState: { ...updated.initialState, OtherReasonOfJoining: null } };
      }
      setFormData(updated);
      return;
    }
    setFormData(nextFormDataBase);
  };

  const handleSubmit = () => {
    let formData = otherInformationRef.current.getFormData();
    if (!formData) {
      error("Please fill in all mandatory fields to continue.", "")
      return;
    }
    let req = {
      SGBCCorporateMemberId: props.id,
      Howdidyoulearnaboutsgbc: formData?.howDidYouLearnSGBCId.length > 0 ? formData?.howDidYouLearnSGBCId?.join(',') : null,
      OtherInformationAboutSGBC: formData?.OtherInformationAboutSGBC || null,
      Anyotherinformationtobeprovidedtosgbc: formData?.otherInformationProvidedtoSGBC || null,
      ReasonforjoiningSGBCCorporateMembership: formData?.reasonOfJoining?.length > 0 ? formData?.reasonOfJoining?.join(',') : null,
      OtherReasonOfJoining: formData?.OtherReasonOfJoining || null,
    }
    updateOtherInformation(req)

  }


  useEffect(() => {
    if (!updateOtherInformationLoading && updateOtherInformationData) {
      const isError = updateOtherInformationData?.keyId == 0;
      ToastService[isError ? "error" : "success"](isError ? "Record was not updated." : "Record updated successfully.");
    }
  }, [updateOtherInformationData, updateOtherInformationLoading])

  useImperativeHandle(ref, () => ({
    getFormData: () => {
      if (ref?.current) {
        return otherInformationRef?.current?.getFormData();
      }
      return null;
    }
  }));


  useEffect(() => {
    if (props.corporateMemberDetails) {
      const details = props.corporateMemberDetails;
      const initialState = {
        howDidYouLearnSGBCId: details.howDidYouLearnSGBCId ? details.howDidYouLearnSGBCId.toString().split(',').map(Number) : null,
        OtherInformationAboutSGBC: details.otherInformationAboutSGBC || "",
        otherInformationProvidedtoSGBC: details.otherInformationProvidedtoSGBC || "",
        reasonOfJoining: details.reasonOfJoining ? details.reasonOfJoining.toString().split(',').map(Number) : null,
        OtherReasonOfJoining: details.otherReasonOfJoining || ""
      };
      let updatedFormData = { ...formData, initialState };

      if (includesValueNormalized(initialState.howDidYouLearnSGBCId, 5) || includesValueNormalized(initialState.howDidYouLearnSGBCId, 4)) {
        updatedFormData = handleConditionBaseFields(initialState.howDidYouLearnSGBCId, updatedFormData, "OtherInformationAboutSGBC", 5, 4);
      }
      if (includesValueNormalized(initialState.reasonOfJoining, 8)) {
        updatedFormData = handleConditionBaseFields(initialState.reasonOfJoining, updatedFormData, "OtherReasonOfJoining", 8);
      }
      setFormData(updatedFormData);
    }
  }, [props.corporateMemberDetails]);

  return (
    <>
      <Accordion title="Other Information" button={false} buttonLabel="Analytics">
        <div className="row">
          <FormCreator
            ref={otherInformationRef}
            {...formData}
            onFormFieldValueChange={handleFormFieldChange} />
        </div>
        <div className="btn-right-side">
          <Buttons
            buttonText="Save"
            buttonTypeClassName="success-btn"
            onClick={handleSubmit}
            isLoading={updateOtherInformationLoading}
            isDisable={props?.roleId === 12}
          />
        </div>
      </Accordion>

    </>
  )
})
export default OtherInformation
